import React, {useState} from 'react';
import { Button } from 'react-bootstrap';
import PartnerDatatable from '../../modules/partner/PartnerDatatable';
import PartnerModal from '../../modules/partner/PartnerModal';



const Partners = (props) => {

      const [show , setShow]= useState( false );   
      const [recordId, setRecordId ] = useState( "" );
    
      
   
    
  
      const handleCallback = (id) => {
            setRecordId(id);       
            setShow(true);   
        
      };
   
      const modalCallback = (isShow,id) => {             
        setRecordId(id);       
        setShow(isShow);       
        //setDataChanged(dataChanged) ;         
      }
  
  
     
  
    return (
        <>
               <PartnerDatatable
                    parentCallback={handleCallback}                   
                    partnerType={props.partnerType}
                    modalShow={show}
                />
              
               <PartnerModal 
                    show={show}
                    parentCallback={modalCallback}
                    selectedRecord={recordId}                  
                    partnerType={props.partnerType}               
                />
                
                <Button
                    bsStyle="primary"          
                    className="ml-3 mt-3"
                    onClick={() => handleCallback('')}
                ><i class="fas fa-plus"></i>
                </Button>
        </>
    );
};

 
 export default Partners;